import React from 'react';
import '../styles/CompaniesTable.css';
import moment from 'moment';
import { colour, formatterLong, numberFormatter } from '../styles/GlobalStyles';
import { Badge, Button } from './';

function CompaniesTable(props) {
    const data = props.data;
    const openNewCompanyModal = props.openNewCompanyModal;
    const setShowUsersPanel = props.setShowUsersPanel;
    const setCompanyUsersId = props.setCompanyUsersId;
    const adminCompanyIds = JSON.parse(process.env.REACT_APP_ADMIN_COMPANY_IDS);

    const headings = [
        {
            preIcon: null,
            label: "Company",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Subscription status",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Price",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Start date",
            postIcon: null
        },
        {
            preIcon: null,
            label: "End date",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Stripe ID",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Credits remaining",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Users",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Actions",
            postIcon: null
        }
    ];

    const getSubscriptionStatus = (item) => {
        const autoBilling = item.data.autoBilling;
        const today = new Date();
        const todaySeconds = today.getTime() / 1000;
        const endDate = item.data.endDate._seconds;
        if ( endDate > todaySeconds && autoBilling === true ) {
            const status = "Active";
            const bgColour = "bg-colour-jade-01";
            const dotColour = colour.jade02;
            return {
                status: status,
                bgColour: bgColour,
                dotColour: dotColour
            };
        }
        else if ( endDate > todaySeconds && autoBilling === false ) {
            const status = "Cancelled";
            const bgColour = "bg-colour-red-01";
            const dotColour = colour.red02;
            return {
                status: status,
                bgColour: bgColour,
                dotColour: dotColour
            };
        }
        else {
            const status = "Expired";
            const bgColour = "bg-colour-light";
            const dotColour = colour.gray03;
            return {
                status: status,
                bgColour: bgColour,
                dotColour: dotColour
            };
        }
    };

    const viewUsers = (id) => {
        setShowUsersPanel(true);
        setCompanyUsersId(id);
    };

    return (
        <div className="companies-table-outer-container">
            <div className="companies-table-button-container">
                <Button
                    buttonType="primary-button"
                    size="large"
                    text={"New company"}
                    cta={openNewCompanyModal}
                    disabled={false}
                    leftIcon={null}
                    leftIconClass=""
                    rightIcon={null}
                    rightIconClass=""
                    alt=""
                    standardIcon={false}
                    badge={false}
                    badgeVal={null}
                    badgeBG={null}
                    buttonRef={null}
                    spinner={false}
                />
            </div>
            <table 
                className="companies-table-container"
            >
                <thead className="">
                    <tr className="bg-colour-white">
                        {
                            headings.map((item, index) =>
                                <th 
                                    className="companies-table-label-element"
                                    key={index}
                                >
                                    <span className="body-regular colour-secondary">
                                        {item.label}
                                    </span>
                                </th>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item, index) =>
                            !adminCompanyIds.includes(item.data.companyId) &&
                            <tr 
                                key={index}
                                className=""
                            >
                                <td className="companies-table-value-element">
                                    <span className="body-semibold colour-primary">
                                        {item.data.companyName}
                                    </span>
                                </td>
                                <td className="companies-table-value-element">
                                    <div className="companies-table-badge-container">
                                        <Badge
                                            bgColour={getSubscriptionStatus(item).bgColour}
                                            text={getSubscriptionStatus(item).status}
                                            statusDot={true}
                                            statusDotColour={getSubscriptionStatus(item).dotColour}
                                            textClass="body-semibold colour-primary"
                                            icon={null}
                                            tooltip={false}
                                            tooltipBody={null}
                                            tooltipPosition={null}
                                            iconLeft={false}
                                        />
                                    </div>
                                </td>
                                <td className="companies-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {formatterLong.format(item.data.price).replace(".00", "")}
                                        {
                                            item.data.monthly === true ?
                                            "/month"
                                            :
                                            "/year"
                                        }
                                    </span>
                                </td>
                                <td className="companies-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {moment.unix(item.data.startDate._seconds).format("MMM DD, YYYY")}
                                    </span>
                                </td>
                                <td className="companies-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {moment.unix(item.data.endDate._seconds).format("MMM DD, YYYY")}
                                    </span>
                                </td>
                                <td className="companies-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {item.data.id}
                                    </span>
                                </td>
                                <td className="companies-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {numberFormatter.format(item.data.credits)}
                                    </span>
                                </td>
                                <td className="companies-table-value-element">
                                    <span 
                                        className="body-semibold colour-primary underline cursor-pointer"
                                        onClick={() => viewUsers(item.id)}
                                    >
                                        {item.data.users.length} users
                                    </span>
                                </td>
                                <td className="companies-table-value-element">

                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
};

export default CompaniesTable;